import Flickity from 'flickity'
import 'flickity-imagesloaded'

const promotedPostsCarousel = ($el) => {
    if (typeof $el !== 'undefined' && $el != null) {
        const promotedPostsCarousel = [
            ...$el.querySelectorAll('.js-promoted-posts-carousel-rail'),
        ]
        const isDisabledClass = 'is-disabled'

        if (
            typeof promotedPostsCarousel !== 'undefined' &&
            promotedPostsCarousel != null
        ) {
            /**
             * Set flickity options
             */
            const options = {
                cellAlign: 'center',
                contain: false,
                pageDots: true,
                prevNextButtons: false,
                setGallerySize: true,
                imagesLoaded: true,
                wrapAround: false,
                cellSelector: '.news-card-promoted',
            }

            promotedPostsCarousel.forEach((carousel) => {
                /**
                 * Instantiate new flickty
                 */
                const flkty = new Flickity(carousel, { ...options })

                /**
                 * Hook up navigation instance
                 */
                const previousButton =
                    carousel.parentNode.parentNode.querySelector(
                        '.js-promoted-posts-carousel-nav-prev'
                    )
                const nextButton = carousel.parentNode.parentNode.querySelector(
                    '.js-promoted-posts-carousel-nav-next'
                )

                //prev
                if (previousButton) {
                    previousButton.addEventListener('click', () => {
                        flkty.previous()
                    })
                }

                // next
                if (nextButton) {
                    nextButton.addEventListener('click', () => {
                        flkty.next()
                    })
                }

                /**
                 * Enable or disable nav buttons
                 */
                previousButton.classList.add(isDisabledClass)

                flkty.on('cellSelect', () => {
                    if (!flkty.cells[flkty.selectedIndex - 1]) {
                        previousButton.classList.add(isDisabledClass)
                        nextButton.classList.remove(isDisabledClass)
                    } else if (!flkty.cells[flkty.selectedIndex + 1]) {
                        nextButton.classList.add(isDisabledClass)
                        previousButton.classList.remove(isDisabledClass)
                    } else {
                        previousButton.classList.remove(isDisabledClass)
                        nextButton.classList.remove(isDisabledClass)
                    }
                })
            })
        }
    }
}

export default promotedPostsCarousel
